import type { MutationHookOptions } from '@apollo/client'
import { MyTrainingRequestsDatatableDocument } from 'generated/resources/datatable.graphql'
import {
  RejectTrainingRequestDocument,
  RejectTrainingRequestMutation,
  RejectTrainingRequestMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  RejectTrainingRequestMutation,
  RejectTrainingRequestMutationVariables
>

export const useRejectTrainingRequest = (options?: Options) => {
  const [rejectTrainingRequest, { loading }] = useMutation(RejectTrainingRequestDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.rejectTrainingsTrainingRequest,
  })

  return {
    loading,
    reject(variables: RejectTrainingRequestMutationVariables) {
      return rejectTrainingRequest({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [MyTrainingRequestsDatatableDocument],
      })
    },
  }
}
